import { Box, IconButton, Link, useTheme } from '@mui/material'

import { FacebookIcon } from 'src/assets/icons/v2/FacebookIcon'
import { InstagramIcon } from 'src/assets/icons/v2/InstagramIcon'
import { LinkedInIcon } from 'src/assets/icons/v2/LinkedInIcon'
import { TwitterIcon } from 'src/assets/icons/v2/TwitterIcon'
import { YoutubeIcon } from 'src/assets/icons/v2/YoutubeIcon'
import { ISocialUsernames } from 'src/types'

interface IProps {
  socials: ISocialUsernames
}

export const AccountSocials = ({ socials }: IProps) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        p: '10px',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
      }}
    >
      {socials?.facebook && (
        <IconButton
          component={Link}
          target="_blank"
          href={socials.facebook}
          sx={{
            width: '35px',
            height: '35px',
            border: `1px solid ${theme.palette.custom.darkBlue2}`,
            borderRadius: '50%',
            p: '5px',
          }}
        >
          <FacebookIcon size={35} fill={theme.palette.custom.darkBlue2} />
        </IconButton>
      )}
      {socials?.instagram && (
        <IconButton
          component={Link}
          target="_blank"
          href={socials.instagram}
          sx={{
            width: '35px',
            height: '35px',
            border: `1px solid ${theme.palette.custom.darkBlue2}`,
            borderRadius: '50%',
            p: '5px',
          }}
        >
          <InstagramIcon size={35} fill={theme.palette.custom.darkBlue2} />
        </IconButton>
      )}
      {socials?.linkedin && (
        <IconButton
          component={Link}
          target="_blank"
          href={socials.linkedin}
          sx={{
            width: '35px',
            height: '35px',
            border: `1px solid ${theme.palette.custom.darkBlue2}`,
            borderRadius: '50%',
            p: '5px',
          }}
        >
          <LinkedInIcon size={35} fill={theme.palette.custom.darkBlue2} strokeWidth={1.5} />
        </IconButton>
      )}
      {socials?.x && (
        <IconButton
          component={Link}
          target="_blank"
          href={socials.x}
          sx={{
            width: '35px',
            height: '35px',
            border: `1px solid ${theme.palette.custom.darkBlue2}`,
            borderRadius: '50%',
            p: '5px',
          }}
        >
          <TwitterIcon size={17} fill={theme.palette.custom.darkBlue2} />
        </IconButton>
      )}
      {socials?.youtube && (
        <IconButton
          component={Link}
          target="_blank"
          href={socials.youtube}
          sx={{
            width: '35px',
            height: '35px',
            border: `1px solid ${theme.palette.custom.darkBlue2}`,
            borderRadius: '50%',
            p: '5px',
          }}
        >
          <YoutubeIcon
            size={35}
            fill={theme.palette.custom.darkBlue2}
          />
        </IconButton>
      )}
    </Box>
  )
}
